import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { PermissionsService } from '@services/permissions.service';
import { combineLatest, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthCoordenadorConteudoOrRepresentanteCPBGuard implements CanLoad {

    constructor(
        private permissionsService: PermissionsService,
        private router: Router
    ) { }

    public canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> | Observable<boolean> {
        return combineLatest(this.permissionsService.isCoordenadorConteudo$, this.permissionsService.isRepresentanteCPB$).pipe(
            switchMap(resp => !!resp ? of(true) : this.router.navigate(['/']))
        )
    }
}
